<template>
    <div class="component order-cancellation-rationales">
        <template v-if="isLoading">
            <v-progress-circular
                :size="16"
                indeterminate
                color="#2f9bd9"
            ></v-progress-circular>
        </template>
        <template v-else>
            <template v-if="cancellationReasons && cancellationReasons.length">
                <v-radio-group v-model="selected" @change="onChange">
                    <v-radio
                        v-for="item in cancellationReasons"
                        :key="item.id"
                        :label="item.reason"
                        :value="item"
                    ></v-radio>
                </v-radio-group>
            </template>
            <template v-else>
                <div>
                    No cancellation reasons
                </div>
            </template>
        </template>
    </div>
</template>

<script type="text/babel">
    import {VRadio, VRadioGroup,VProgressCircular} from 'vuetify/lib'
    import RunbuggyClient from '@/clients/runBuggyApi'


    export default {
        name: 'components-order-cancellation-rationales-selector',
        watch: {},
        props: {
            value: {
                required: false
            },
            token: {
                required: false
            }
        },
        data() {
            return {
                isLoading: true,
                cancellationReasons: undefined,
                selected: this.value
            }
        },
        methods: {
            getReasonsForCancelingOrder() {
                this.isLoading = true;

                let group = 'OrderCancellation';
                return RunbuggyClient.getRationales(group, this.token)
                .then((response) => {
                    this.cancellationReasons = response.data;

                    if (this.value) {
                        this.selected = this.cancellationReasons.find(item => item.reason = this.value.message);
                    }
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.isLoading = false;
                });
            },
            onChange(event) {
                this.$emit('input', {
                    type: this.selected.type,
                    message: this.selected.reason
                });
            }
        },
        computed: {},
        created() {
        },
        mounted() {
            this.getReasonsForCancelingOrder();
        },
        beforeDestroy() {
        },
        mixins: [],
        components: {
            VRadio,
            VRadioGroup,
            VProgressCircular,
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    label {
        margin-left: 0.5rem;
    }
</style>
